const queryConfig = {
    "RECENT_SEARCH_PLACES": "recent-search-places",

}

export default queryConfig;